import React from 'react';

import { Container, Circle, Title } from './BubbleStep.styled';
import { CheckMark } from 'assets/icons/Icons';

import { Props } from './BubbleStep.types';

const BubbleStep: React.FC<Props> = (props: Props) => {
  const { title, status, withTitles } = props;
  return (
    <Container>
      <Circle status={status}>{status === 'Completed' && <CheckMark type="solid" />}</Circle>
      {withTitles && <Title status={status}>{title}</Title>}
    </Container>
  );
};

export default BubbleStep;
